import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemInfoPopoverComponent } from '../../components/item-info-popover/item-info-popover.component';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { ListLanguageFlagsComponent } from '../../components/list-language-flags/list-language-flags.component';
import { ItemRatingComponent } from '../../components/item-rating/item-rating.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import Session from '../../utils/session.service';
import UserService from '../../services/user.service';
import CategoryService from '../../services/category.service';
import DialogServices from '../../services/dialog.service';
import ModalService from '../../services/modal.service';
import FetchingService from '../../services/fetching.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import moment from 'moment';
import { Input } from '@angular/core';
import { ModalBookingEnquiryComponent } from '../modal-booking-enquiry/modal-booking-enquiry.component';
import { ModalPartnerContactRequestComponent } from '../modal-partner-contact-request/modal-partner-contact-request.component';
import { ModalMediaComponent } from '../../components/modal-media/modal-media.component';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'card-service',
	templateUrl: './card-service.component.html',
	imports: [
		CommonModule, ModalMediaComponent, DatePipe,
		ArrayLimitToPipe, StartFromPipe, LowerCasePipe, TranslatePipe, 
		ItemInfoPopoverComponent, AvatarComponent, ListLanguageFlagsComponent, ItemRatingComponent
	]
})
export class CardServiceComponent implements OnInit, OnDestroy {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private session: Session = inject(Session);
	private userService: UserService = inject(UserService);
	private categoryService: CategoryService = inject(CategoryService);
	private dialogServices: DialogServices = inject(DialogServices);
	private modalService: ModalService = inject(ModalService);
	private fetchingService: FetchingService = inject(FetchingService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() therapyTranslations: any;
	@Input() isMinimal: any | undefined;
	@Input() partnerMode: any | undefined;
	@Input() service: any;
	
	vm: any = undefined;
	walletSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.hasIiziBusinessWallet = false;
		this.vm.user = this.session.getSession().user;
		this.vm.sessionUserLanguage = this.vm.user.deviceLanguage;
		this.vm.origin = this.vm.user.origin;
		this.vm.isSiffi = this.vm.origin == 'siffi.com';
		this.vm.isMinuDoc = this.vm.origin == 'minudoc.ee';
		this.vm.locale = (this.vm.user.deviceLanguage || 'et_EE').slice(0, 2);
		this.vm.charLimit = 180;
		
		var params = {
				subcategory: this.vm.service.subcategory,
				furtherSubcategory: this.vm.service.furtherSubcategory
			};
		this.categoryService.getTranslation(params).then((category) => {
			this.vm.category = category;
			this.getTherapies().then(() => {
				this.initializeService();
			});
		});
		
		// this.angularStateHelperService.scopeWF(this, this.userService.getWallet, this.handleWalletUpdate, true);
		this.walletSubscription = this.angularBroadcastHelperService.onEvent(this, "walletChanged", (event, newWallet) => {
			this.handleWalletUpdate(newWallet);
		});
		this.userService.getWallet(); // TODO ANGULAR_2: should this be inside an interval?
		
		this.vm.openVideo = this.openVideo;
		this.vm.openDescription = this.openDescription;
		this.vm.closeOverlay = this.closeOverlay;
		this.vm.openBookingEnquiry = this.openBookingEnquiry;
		this.vm.openPartnerContactRequest = this.openPartnerContactRequest;
		this.vm.openChatBotIntroduction = this.openChatBotIntroduction;
		this.vm.redirectToBooking = this.redirectToBooking;
		this.vm.redirectToDoctorDetails = this.redirectToDoctorDetails;
		this.vm.getBusinessWalletLabel = this.getBusinessWalletLabel;
		this.vm.redirect = this.redirect;
		this.vm.getIconColor = this.getIconColor;
		this.vm.serviceTimeAndPriceTheme = (this.vm.user.origin == 'siffi.com' ? '' : 'c-text--main');
		this.vm.buttonTheme1 = (this.vm.user.origin == 'siffi.com' ? 'c-button--s2' : 'c-button--s1');
		this.vm.textColor = (this.vm.user.origin == 'siffi.com' ? '' : 'c-text--gray');
	}
	
	ngOnDestroy() {
		if (this.walletSubscription) {
			this.walletSubscription.unsubscribe();
		}
	}
	
	initializeService() {
		var d: any = moment(this.vm.service.nextAvailableTime).calendar().split(' ')[0];
		var currencies: any = { 'EUR': '€', 'USD': '$', 'GBP': '£', 'PLN': 'zł', 'RUB': '₽', 'SEK': 'kr', 'DKK': 'kr.', 'NOK': 'kr' };
		this.vm.service.nextAvailableDate = (d === 'Today' || d === 'Tomorrow')
			? this.angularFilterHelperService.translate('Services.Time.' + d).toLowerCase()
			: this.angularFilterHelperService.formatDate(this.vm.service.nextAvailableTime, 'dd.MM.yy');
		this.vm.service.priceWithUnits = this.vm.service.pricing.price + currencies[this.vm.service.pricing.currency];
		this.vm.service.languages = this.vm.service.languagesSummary
			? this.vm.service.languagesSummary
				.split('·')
				.map(l => l.trim())
				.filter((el, i, a) => el && i === a.indexOf(el))
			: [];
		this.vm.service.occupation = this.vm.category;
		if (!!this.vm.service.occupation) {
			this.vm.service.company = (this.vm.service.parentServiceTitle) ? (', ' + this.vm.service.parentServiceTitle) : '';
		} else {
			this.vm.service.company = (this.vm.service.parentServiceTitle) ? (this.vm.service.parentServiceTitle) : '';
		}
		this.vm.service.license = (this.vm.service.licenseNumber)
			? this.angularFilterHelperService.translate('Subscription.Label.LicenseNumber') + ': ' + this.vm.service.licenseNumber
			: '';
		if (this.vm.service.descriptions) {
			var idx: any = -1;
			for (var i = 0, len = this.vm.service.descriptions.length; i < len; i++) {
				if (this.vm.service.descriptions[i].language === this.vm.locale && idx < 0) idx = i;
			}
			if (idx < 0) {
				// try to fall back to English
				for (var i = 0, len = this.vm.service.descriptions.length; i < len; i++) {
					if (this.vm.service.descriptions[i].language === 'en' && idx < 0) idx = i;
				}
			}
			if (idx >= 0) {
				this.vm.service.description = this.vm.service.descriptions[idx].description;
				this.vm.service.priceDisclaimer = this.vm.service.descriptions[idx].priceDisclaimer;
			}
		}
		
		this.vm.isServiceInitialized = true;
		this.handlePriceUpdate();
		if (this.vm.service.therapies) {
			this.vm.selectedTherapies = [];
			THERAPIES: for (var st = 0; st < this.vm.service.therapies.length; st++) {
				for (var t = 0; t < this.vm.therapyTranslations.length; t++) {
					if (this.vm.service.therapies[st].therapy.id === this.vm.therapyTranslations[t].therapy.id) {
						this.vm.selectedTherapies.push(this.vm.therapyTranslations[t]);
						continue THERAPIES;
					}
				}
			}
			this.vm.selectedTherapiesLengthWithoutFirst = this.vm.selectedTherapies.length > 1
				? this.vm.selectedTherapies.length - 1
				: this.vm.selectedTherapies.length;
		}
	}
	
	getTherapies() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.fetchingService.get('THERAPY_TOPIC_TRANSLATIONS', { params: { language: this.vm.sessionUserLanguage || 'en_GB' } })
			.then((response) => {
				this.vm.therapyTranslations = response;
				deferred.resolve();
			});
		return deferred.promise;
	}

	getIconColor(type: 'video' | 'onsite'): string {
		const appointmentType = this.vm?.service?.typeOfAppointment;
		const origin = this.vm?.origin;
		const activeColor = origin === 'siffi.com' ? '#287638' : origin === 'minudoc.ee' ? '#004cdd' : 'rgba(208,203,203,0.46)';
		const grey = 'rgba(208,203,203,0.46)';

		if (type === 'video') {
			if (appointmentType === 'VIDEO_SESSION_ONLY' || appointmentType === 'VIDEO_AND_FACE_TO_FACE_SESSIONS') {
				return activeColor;
			}
		} else if (type === 'onsite') {
			if (appointmentType === 'FACE_TO_FACE_SESSION_ONLY' || appointmentType === 'VIDEO_AND_FACE_TO_FACE_SESSIONS') {
				return activeColor;
			}
		}

		return grey;
	}


	handleWalletUpdate(wallet) {
		if (this.angularHelperService.equals(wallet, this.vm.wallet)) return;
		this.vm.wallet = wallet || {};
		var hasIiziBusinessWallet: any = (this.vm.wallet['alternatives'] || []).find(function(wallet) {
			var isInsuranceType: any = (wallet['walletType'] || '').toLowerCase() === 'insurance';
			var isIiziPackageName: any = (wallet['name'] || '').toLowerCase() === 'iizi';
			return (isInsuranceType && isIiziPackageName);
		});
		if (hasIiziBusinessWallet){
			this.vm.hasIiziBusinessWallet = true;
		}
		this.handlePriceUpdate();
	}
	
	handlePriceUpdate() {
		this.userService.getWalletWithPrice(this.vm.service)
		.then((usedWallet) => {
			this.vm.isCoveredByBusinessWallet = (!usedWallet.price || usedWallet.coPayWallet) && this.vm.service.pricing.price;
			this.vm.showBusinessWalletLabel = !this.vm.partnerMode && this.vm.isCoveredByBusinessWallet;
			if (usedWallet.alternative) {
				if (usedWallet.coPayWallet) {
					this.vm.walletName = usedWallet.coPayWallet.wallet.name;
					this.vm.insuranceCoPay = true;
				} else {
					this.vm.walletName = usedWallet.wallet.name;
				}
			}
			this.vm.isInitialized = this.vm.isServiceInitialized;
		})
		.catch(() => {
			this.vm.showBusinessWalletLabel = false;
			this.vm.isInitialized = this.vm.isServiceInitialized;
		});
	}
	
	redirect($event, link) {
		$event.preventDefault();
		window.open(link, '_blank');
	}
	
	getBusinessWalletLabel() {
		if (this.vm.insuranceCoPay) {
			return 'Services.Other.Insurance_Cover';
		} else if (this.vm.walletName?.toLowerCase() === 'iizi') {
			return 'Services.Other.Package_By';
		} else {
			return 'Services.Other.Covered_By';
		}
	}
	
	redirectToBooking() {
		if (!this.vm.redirectStarted) {
			this.vm.redirectStarted = true;
			var storage: any = window.sessionStorage;
			var booking: any = { service: this.vm.service.id };

			this.vm.params = this.angularRoutingHelperService.getQueryParams();
			if (this.vm.params['coachingTopics']) {
				this.fetchingService.get('COACHING_TOPICS', { params: { language: this.vm.user.deviceLanguage || 'en_GB' } })
				.then((response) => {
					var coachingTopics: any = response;
					var selectedCoachingTopics: any = "" + this.vm.params['coachingTopics'];
					var coachingTitles: any = "";
					for (var i = 0; i < coachingTopics.length; i++) {
						if (selectedCoachingTopics.indexOf(coachingTopics[i].id) > -1
						&& (coachingTitles.length + coachingTopics[i].title.length) < 300) {
							if (coachingTitles) {
								coachingTitles += ", ";
							}
							coachingTitles += coachingTopics[i].title;
						}
					}
					booking.comment = coachingTitles;
					
					storage.setItem('booking', JSON.stringify(booking));
					//this.angularRoutingHelperService.clearQueryParamsDirty()
					this.angularRoutingHelperService.setPath(['booking/service/', this.vm.service.id]);
				});
			} else {
				storage.setItem('booking', JSON.stringify(booking));
				//this.angularRoutingHelperService.clearQueryParamsDirty()
				this.angularRoutingHelperService.setPath(['booking/service/', this.vm.service.id]);
			}
		}

	}
	
	redirectToDoctorDetails() {
		this.vm.params = this.angularRoutingHelperService.getQueryParams();
		this.angularRoutingHelperService.clearQueryParamsDirty()
		if (this.vm.params['coachingTopics']) {
			this.angularRoutingHelperService.setPath(['specialist/', this.vm.service.id], false, false,
				{ coachingTopics: this.vm.params['coachingTopics'] });
		} else {
			this.angularRoutingHelperService.setPath(['specialist/', this.vm.service.id]);
		}
	}
	
	openVideo($event) {
		$event.preventDefault();
		this.vm.service.profileVideoPost.postType = 'VIDEO';
		this.modalService.openMedia(
			ModalMediaComponent,
			{
				media: this.vm.service.profileVideoPost,
				chat: {},
				modalId: 'modal-' + (this.vm.service.profileVideoPost.id
					? this.vm.service.profileVideoPost.id
					: this.vm.service.profileVideoPost.uuid)
			}
		);
	}
	
	openDescription() {
		this.vm.overlayContent = 2;
		this.vm.overlayOpen = true;
	}
	
	openBookingEnquiry() {
		this.dialogServices.show({
			controller: ModalBookingEnquiryComponent,
			service: this.vm.service
		});
	}

	openPartnerContactRequest() {
		this.dialogServices.show({
			controller: ModalPartnerContactRequestComponent,
			service: this.vm.service
		});
	}
	
	openChatBotIntroduction(serviceId) {
		this.angularRoutingHelperService.setPath(['/chatbot', serviceId]);
	}
	
	closeOverlay() {
		this.vm.overlayOpen = false;
		this.vm.overlayContent = false;
	}
	
}
